import React from "react";
import { navigate } from "gatsby"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import People from "@material-ui/icons/People";
import LockOutlined from "@material-ui/icons/LockOutlined";
// React icons
import { FaFacebook, FaTwitter, FaGooglePlusG } from 'react-icons/fa';
// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import firebase from "gatsby-plugin-firebase"
import "firebase/auth";

import RssFeed from '../../components/RssFeed/RssFeed.jsx'

import { Router } from "@reach/router"


import loginPageStyle from "assets/jss/material-kit-react/views/loginPage.jsx";

import image from "assets/img/LoginBackground.jpg";


class InformationPage extends React.Component {
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
           
        };
    }
    componentDidMount() {


    }


    render = () => {
        const { classes, feedURL, ...rest } = this.props;

        return (
            <div>
                <Header
                    absolute
                    color="transparent"
                    brand="Material Kit React"
                    rightLinks={<HeaderLinks />}
                    {...rest}
                />
                <div
                    className={classes.pageHeader}
                    style={{
                        backgroundImage: "url(" + image + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "top center"
                    }}
                >
                    <div className={classes.container}>
                        
                            
                            <RssFeed feedURL={feedURL} feedType="feed" />
                            
                        
                        <br></br>
                    </div>
                    <Footer whiteFont />
                </div>
            </div>
        );
    }
}

export default withStyles(loginPageStyle)(InformationPage);
